<template>
  <div class="history">
    <div class="history-inner inner">
      <ul class="inner-list">
        <li>
          <PersonIcon
          type-img="miniBlue"
        />
        </li>
      </ul>
    </div>
    <div class="history-footer">
      <BaseBtn
        text="Восстановить версию"
      />
    </div>
  </div>
</template>

<script>
import BaseBtn from '@/components/ui/BaseBtn.vue'
import PersonIcon from '@/components/icons/PersonIcon.vue'

export default {
  name: 'HistoryChangeModules',
  components: {
    BaseBtn,
    PersonIcon
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>
.history {
  padding: 18px 25px 14px 20px;
  width: 511px;
  height: 368px;
  background-color: #FFF;
  border-radius: 10px;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
</style>
